import React, { CSSProperties, useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import styles from './_search-bar.module.scss';

export interface SearchBarProps {
  placeholder: string;
  onSearchInputChange: (searchText: string) => void;
  onEscapeKey?: () => void;
  style?: CSSProperties;
  autoFocus?: boolean;
}

export default function SearchBar(props: SearchBarProps) {
  const [searchText, setSearchText] = useState<string>('');
  return (
    <FormControl className={styles.searchBarContainer} variant='outlined' style={props.style}>
      <OutlinedInput
        className={styles.searchInput}
        type={'text'}
        placeholder={props.placeholder}
        autoFocus={props.autoFocus}
        value={searchText}
        onChange={(e) => {
          props.onSearchInputChange(e.target.value);
          setSearchText(e.target.value);
        }}
        onKeyUp={(e) => {
          if (props.onEscapeKey && e.key === 'Escape') {
            props.onEscapeKey();
          }
        }}
        endAdornment={<SearchIcon style={{ color: 'rgb(105, 105, 105)' }} />}
      />
    </FormControl>
  );
}
